import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import api from '@webparts/api/graph';
import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';

@Component({})
export default class PeopleList extends UserCardComponent {      
    mPeoples: account.User[] = [];

    currentPage: number = 1;  
    lastPage: number | null = null;
    pageSize: number = 0; 
    nextLink: string | null = null;
    isLoading: boolean = false;
    resizeTimeout: number = 0;

    resizeObserver: ResizeObserver | null = null;
    elemToWatch: HTMLElement | null = null;

    get peoples() {
        return this.mPeoples.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    }

    getPhotoPath(people: account.User) {
        if (people.photoPath) {
            return people.photoPath;
        } else {
            return '/cm/gres/faux/images/ghost.png'
        }
    }
   
    resizeMount() {
        let ulElem = this.$refs.refUlPeople as HTMLUListElement;
        let ulSize = ulElem.clientWidth;    
        let changedSize = Math.floor((ulSize - 2)/120);      

        changedSize = changedSize <= 0 ? 1 : changedSize;

        if(this.pageSize !== changedSize) {
            this.currentPage = 1;
            this.pageSize = changedSize;
            this.nextLink = null;
            this.mPeoples = [];
            this.mountAction();
        }
    }

    mountAction(): Promise<void> {
        this.isLoading = true;
        let ulElem = this.$refs.refUlPeople as HTMLUListElement;
        let ulSize = ulElem.clientWidth;    
        let changedSize = Math.floor((ulSize - 2)/120);     
        
        changedSize = changedSize <= 0 ? 1 : changedSize;

        return api.getMyPeoples({
            currentPage: this.currentPage,
            pageSize: changedSize,
            nextLink: this.nextLink,
        }).then(res => {
            this.pageSize = changedSize;
            this.currentPage = res.currentPage;
            this.nextLink = res.nextLink;
            this.mPeoples.push(...res.items);

            if(res.nextLink == null) {
                this.lastPage = this.currentPage;
            }
        }).finally(() => {           
            this.$emit('mounted', this.mPeoples);
            this.isLoading = false;                               
        });
    }

    handlePrev() {
        if (this.currentPage == 1) return;
        this.currentPage--;
    }

    handleNext() {
        this.currentPage++;
        
        if (this.mPeoples.length - 1 < ((this.currentPage - 1) * this.pageSize)) {
            this.mountAction();
        }        
    }

    handleUlResize() {                             
        clearTimeout(this.resizeTimeout);        
        this.resizeTimeout = setTimeout(() => {    
            this.resizeMount();
        }, 300);              
    }

    mounted() {          
        this.elemToWatch = this.$refs.refUlPeople as HTMLUListElement;
        this.resizeObserver = new ResizeObserver((entries) => this.handleUlResize());        
                
        this.mountAction().then(() => {
            if(this.elemToWatch && this.resizeObserver) {
                this.resizeObserver.observe(this.elemToWatch);    
            }                    
        })        
    }

    beforeDestroy() {        
        if(this.elemToWatch && this.resizeObserver) {
            this.resizeObserver.unobserve(this.elemToWatch);           
        } 
    }
}
